import React from "react";

import {
  Autocomplete,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import { useUserContext, useUserContextSetters } from "contexts/UserContext";

const FRAME_DATA = {
  imgSrc: "/static/img/solutions/green-energy.png",
  imgAlt: "Um painel solar com uma avaliação positiva",
  title: "Contrato de energia verde",
  buttonText: "Contratar para outro imóvel",
  currentStep: 0,
  totalSteps: 6,
};
const OFFER_SELECTION_PAGE = "/onboarding/green-energy-offers";
const BUILDING_BASICS_PAGE = "/onboarding/building-basics";

export const GreenEnergyContracts = ({ history }) => {
  const { currentSpace, automationSpaces } = useUserContext();
  const { setCurrentSpace } = useUserContextSetters();
  const handleNavigation = (choice: "new" | "existing") => {
    history.push(
      choice === "new" ? BUILDING_BASICS_PAGE : OFFER_SELECTION_PAGE
    );
  };

  const handleSpaceChange = (event, space) => {
    setCurrentSpace(space);
  };

  return (
    <SolutionsFrame
      {...FRAME_DATA}
      onButtonClick={() => handleNavigation("new")}
    >
      <BlockStandard hideDivider>
        <Typography variant="h2">Muito bom!</Typography>
        <Typography variant="h3" fontWeight="normal">
          Consumir energia renovável é uma excelente forma de reduzir custos com
          energia e descarbonizar.
        </Typography>
        <Typography variant="h3">
          Indique o imóvel para o qual busca solução para verificarmos as
          melhores ofertas pra você:
        </Typography>

        <BlockStandard hideDivider>
          <Grid item container direction="row">
            <Autocomplete
              value={currentSpace}
              /* @ts-ignore-next-line autocomplete's value can teoretically be null */
              onChange={handleSpaceChange}
              sx={{ flex: 1 }}
              options={automationSpaces}
              renderInput={(params) => <TextField {...params} label="Imóvel" />}
              getOptionLabel={({ brand, schoolName }) =>
                `${brand} | ${schoolName}`
              }
            />
            <Button
              sx={{ ml: 2 }}
              variant="contained"
              onClick={() => handleNavigation("existing")}
            >
              Continuar
            </Button>
          </Grid>
        </BlockStandard>
      </BlockStandard>

      <BlockStandard hideDivider>
        <Grid
          container
          item
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <Divider sx={{ width: "100%" }} variant="fullWidth">
            <Typography sx={{ mx: 2 }}> OU </Typography>
          </Divider>
        </Grid>
      </BlockStandard>
    </SolutionsFrame>
  );
};
